module.exports = __webpack_public_path__ + "static/img/20210108090736.EPUgNvaerTyG.22dabe4b.png";